import { addWeeks, getISOWeek, getISOWeekYear, subWeeks } from 'date-fns';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ClassFiltersState {
  studioIds: number[];
  setStudioIds: (studioIds: number[]) => void;

  coachIds: number[];
  setCoachIds: (coachIds: number[]) => void;

  classType: string[]; // filtre de type de classe (Riise)
  setClassType: (classType: string[]) => void; // filtre de type de classe (Riise)

  date: Date;
  setDate: (date: Date) => void;

  week: number;
  year: number;

  setNextWeek: () => void;
  setPreviousWeek: () => void;
}

const useClassFiltersStore = create<ClassFiltersState>()(
  persist(
    (set, get) => ({
      coachIds: [],
      setCoachIds: (coachIds: number[]) => {
        set({ coachIds });
      },

      studioIds: [],
      setStudioIds: (studioIds: number[]) => {
        set({ studioIds });
      },

      classType: [], // filtre de type de classe (Riise)
      setClassType: (classType: string[]) => set({ classType }), // filtre de type de classe (Riise)

      setDate: (date: Date) => set({ date }),

      week: getISOWeek(new Date()),
      year: getISOWeekYear(new Date()),
      date: new Date(),

      setNextWeek: () => {
        const date = addWeeks(get().date, 1);
        const week = getISOWeek(date);
        const year = getISOWeekYear(date);
        set({ date, week, year });
      },

      setPreviousWeek: () => {
        const date = subWeeks(get().date, 1);
        const week = getISOWeek(date);
        const year = getISOWeekYear(date);
        set({ date, week, year });
      },
    }),
    {
      name: 'mindbody-classes-filters',
      partialize(state) {
        return {
          studioIds: state.studioIds,
          coachIds: state.coachIds,
          classType: state.classType, // filtre de type de classe (Riise)
        };
      },
    },
  ),
);

export { useClassFiltersStore };
